export const AT_LAST_CLICKED_ACTIVITY_ID_SET = 'LAST_CLICKED_ACTIVITY_ID_SET';
